<template>
  <v-navigation-drawer 
    v-model="inputValue" 
    fixed 
    left 
    temporary 
    class="tech-drawer"
    width="290"
  >
    <v-row align="center" justify="space-between" class="ma-0 pa-4 flex-no-wrap">
      <v-img contain src="/static/logoNic.png" max-width="80" class="logo-glow" />
      <v-btn aria-label="Close" icon @click="toggleDrawer" class="close-btn-tech">
        <v-icon color="cyan accent-3">mdi-close-network</v-icon>
      </v-btn>
    </v-row>
    
    <div class="neon-line-horizontal"></div>

    <v-list nav dense class="py-4">
      <v-list-item v-for="(item, i) in items" :key="'main'+i" :to="item.to" class="tech-item mb-2">
        <v-list-item-icon class="mr-4">
          <v-icon color="cyan accent-3">mdi-home-variant-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="lista mono-font" v-text="item.text" />
      </v-list-item>

      <v-list-group no-action prepend-icon="mdi-account-circle-outline" color="cyan accent-3" class="tech-group mb-2">
        <template v-slot:activator>
          <v-list-item-title class="lista mono-font">Nosotros</v-list-item-title>
        </template>
        <v-list-item v-for="(link, index) in links" :key="'link1'+index" :to="link.route" class="tech-sub-item">
          <v-list-item-title class="lista mono-font sub-text">{{ link.text }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-group no-action prepend-icon="mdi-upload-network" color="cyan accent-3" class="tech-group mb-2">
        <template v-slot:activator>
          <v-list-item-title class="lista mono-font">Dominios</v-list-item-title>
        </template>
        <v-list-item v-for="(link, index) in links2" :key="'link2'+index" :to="link.route" class="tech-sub-item">
          <v-list-item-title class="lista mono-font sub-text">{{ link.text }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item v-for="(item, i) in items2" :key="'whois'+i" :to="item.to" class="tech-item mb-2">
        <v-list-item-icon class="mr-4">
          <v-icon color="green accent-3">mdi-earth</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="lista mono-font">{{ item.text }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-for="(item, i) in items1" :key="'contact'+i" :to="item.to" class="tech-item mb-2">
        <v-list-item-icon class="mr-4">
          <v-icon color="cyan accent-3">mdi-contacts</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="lista mono-font">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    links: [
      { text: "Quiénes Somos", route: "/QuienesSomos" },
      { text: "Historia", route: "/Historia" },
      { text: "Valores", route: "/Valores" },
      { text: "Corresponsales", route: "/Corresponsales" },
    ],
    // Lista completa de dominios según tu código original
    links2: [
      { text: "Buscar Dominio", route: "/BuscarDominio" },
      { text: "Información General", route: "/InformacionGeneral" },
      { text: "Pasos Para Obtener Dominio", route: "/PasosDom" },
      { text: "Requisisto Para Registro", route: "/requisitos" },
      { text: "Renovación de Dominio", route: "/renovaciondominio" },
      { text: "Registro Nuevo Dominio", route: "/registronuevodominio" },
      
    ],
    items: [{ to: "/", text: "Inicio" }],
    items1: [{ to: "/contactenos", text: "Contáctenos" }],
    items2: [{ to: "/whois", text: "Whois" }],
  }),
  computed: {
    ...mapState(["drawer"]),
    inputValue: {
      get() { return this.drawer; },
      set(val) { this.setDrawer(val); },
    },
  },
  methods: {
    ...mapMutations(["setDrawer", "toggleDrawer"]),
  },
};
</script>

<style scoped>
/* (Se mantienen los estilos tech que definimos anteriormente) */
.tech-drawer { background-color: #080c14 !important; border-right: 1px solid rgba(0, 229, 255, 0.3) !important; }
.mono-font { font-family: 'Fira Code', monospace !important; text-transform: uppercase; }
.lista { color: #fff !important; font-size: 0.85rem !important; }
.sub-text { font-size: 0.75rem !important; color: #b0bec5 !important; }
.tech-item:hover, .v-list-item--active { background: rgba(0, 229, 255, 0.1) !important; border-left: 3px solid #00e5ff !important; }
.neon-line-horizontal { width: 100%; height: 1px; background: linear-gradient(90deg, transparent, #00e5ff, transparent); box-shadow: 0 0 8px #00e5ff; }
</style>